namespace e5 {
    interface HashTableItem<Key = any, Value = any> {
        key: Key;
        value: Value;
    }

    export class HashTable<Key = any, Value = any>{
        private _items: HashTableItem<Key, Value>[] = [];

        public put(key: Key, value: Value): void {
            var item = this.item(key);
            if (item) {
                item.value = value;
            }
            else {
                this._items.push({ key: key, value: value });
            }
        }

        public get(key: Key): Value {
            var item = this.item(key);
            return item ? item.value : undefined;
        }

        public remove(key: Key): void {
            var item = this.item(key);
            if (!item)
                return;
            this._items.splice(this._items.indexOf(item), 1);
        }

        public values(): Value[] {
            var values: Value[] = [];
            for (var item of this._items)
                values.push(item.value);
            return values;
        }

        public keys(): Key[] {
            var keys: Key[] = [];
            for (var item of this._items)
                keys.push(item.key);
            return keys;
        }

        public clear(): void {
            this._items = [];
        }

        private item(key: Key): HashTableItem<Key, Value> {
            for (var entry of this._items) {
                if (entry.key === key)
                    return entry;
            }
            return null;
        }
    }
}